import { deleteDoc, setDoc } from 'firebase/firestore';
import { computed, flow } from 'mobx';
import FirebaseRefListener from './base/FirebaseRefListener';

class FirebaseDoc extends FirebaseRefListener {
  get data() {
    return this.snapshot
      ? this.snapshot.exists()
        ? this.snapshot.data()
        : this.options_.defaults
      : undefined;
  }

  *update(data) {
    if (!this.ref) return Promise.reject('Not initialized');

    this.isUpdating = true;
    try {
      const result = yield setDoc(this.ref, data, { merge: true });
      this.isUpdating = false;
      return result;
    } catch (e) {
      this.isUpdating = false;
      return Promise.reject(e);
    }
  }

  delete() {
    return deleteDoc(this.ref);
  }

  // handleSnapshot(snapshot) {
  //   super.handleSnapshot(snapshot);
  //
  //   this.data = snapshot.data();
  //
  //   this.data2 = snapshot.data();
  //   if (snapshot.data().itemUid) {
  //     console.log('***************+++++++++++++++++++++++++++++++++++*');
  //     console.log('CREATING :::::::::::::::::::');
  //     console.log('THIS DATA', this.data, this.id);
  //     console.log(this);
  //     console.log(
  //       '...................._________________________________________'
  //     );
  //   }
  // }
}

FirebaseDoc.annotations = {
  ...FirebaseRefListener.annotations,
  data: computed,
  update: flow,
};

export default FirebaseDoc;
